import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlatformAnnouncesService } from '../platform-announces.service';
import { AuthService } from 'src/app/services/auth.service';
import { Observable, finalize, of } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { EditPlatformSection } from '../../platform-section/platform-section.interface';
import { PlatformSectionService } from '../../platform-section/platform-section.service';

@Component({
  selector: 'app-edit-platform-announces',
  templateUrl: './edit-platform-announces.component.html',
  styleUrls: ['./edit-platform-announces.component.scss']
})
export class EditPlatformAnnouncesComponent implements OnInit {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error
  errorIcon: string = environment.config.customNotifications.icons.error
  errorType: string = environment.config.customNotifications.icons.error

  token!: string;
  isLoading = false;
  isSectionsLoading = true;
  platformSections$!: Observable<EditPlatformSection[]>;

  form: FormGroup = new FormGroup({
    title: new FormControl(this.data.title),
    content: new FormControl(this.data.content),
    date_start: new FormControl(this.data.date_start.split(' ')[0]),
    date_end: new FormControl(this.data.date_end.split(' ')[0], [this.validateDateRange]),
    section_id: new FormControl(this.data.section_id),
    observations: new FormControl(''),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<EditPlatformAnnouncesComponent>,
    private platformAnnouncesService: PlatformAnnouncesService, 
    private platformSectionsService: PlatformSectionService,
    private notificationService: NotificationService,
    private authService: AuthService) {
      this.processToken();
  }

  ngOnInit(): void {
    this.getSectionsList();
    this.form.get('date_end')?.updateValueAndValidity();
  }

  validateDateRange(control: AbstractControl) {
    const startDate = control.parent?.get('date_start')?.value;
    const endDate = control.value;

    if (startDate && endDate && startDate > endDate) {
      return { dateRangeError: true };
    }

    return null;
  }

  getSectionsList() {
    this.platformSections$ = this.platformSectionsService.getPlatformSections();
    this.platformSections$
    .pipe(
      finalize(() => (this.isSectionsLoading = false))
    )
    .subscribe({
      next: (platformSections) => {
        this.platformSections$ = of(platformSections);
        this.isSectionsLoading = false;
      },
      error: () => {
        let errorMessage = environment.config.customNotifications.generalMessages.error;
        this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
        this.isSectionsLoading = false;
      },
    });
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token
      this.platformAnnouncesService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const updatedPlatformAnnounceData = {
      title: this.form.get('title')?.value,
      content: this.form.get('content')?.value,
      date_start: this.form.get('date_start')?.value,
      date_end: this.form.get('date_end')?.value,
      section_id: this.form.get('section_id')?.value,
      observations: this.form.get('observations')?.value,
      id: this.data.id,
    };

    this.platformAnnouncesService
      .updatePlatformAnnounce(updatedPlatformAnnounceData)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe({
        next: () => {
          this.dialogRef.close({success:true})
        },
        error: () => {
          let errorMessage = environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon)
        }
      })
  }

  onHttpError(res: any) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        this.notificationService.warningSwal(this.errorTitle, msg, this.errorIcon);
      });
    }
    else {
      let errorMessage = environment.config.customNotifications.generalMessages.error;
      this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
    }
  }
}
